import { Select } from '@appd/uik';
import { useEffect, useState } from 'react';

export const Filter = (props: Record<string, any>): JSX.Element => {
  const {
    initialValue = [],
    multiple = true,
    value,
    options = [],
    onChange,
    placeholder,
    editMode,
    title = '',
  } = props;

  /**
   * per convo with UIK, we are still setting initial value directly via value
   * Select.searchable.initialValue is really intended for Form to get the values out on submit/apply
   * for more complete use cases, refer to UIK QuickFilter and UIK FilterBar
   */
  const [filterValue, setFilterValue] = useState([]);

  /**
   * Set value based on filters found in URL params
   */
  useEffect(() => {
    const indexes = toIndexes(value);

    if (indexes.length) {
      setFilterValue(indexes);
      onChange(toValue(indexes));
    }
  }, [value]);

  /**
   * Set intial value of filters
   */
  useEffect(() => {
    if (filterValue.length === 0 && initialValue.length > 0) {
      const indexes = toIndexes(initialValue);

      if (indexes.length) {
        setFilterValue(indexes);
        onChange(toValue(indexes));
      }
    }
  }, [options, filterValue, initialValue]);

  /**
   * Returns the indexes of the given values.
   */
  const toIndexes = (data: any[]) =>
    options.reduce((mem: any[], o: any, i: number) => {
      if (data && data.indexOf(o.value) > -1) {
        mem.push(i);
      }

      return mem;
    }, []);

  /**
   * Returns the option.value for every selected index
   */
  const toValue = (indexes: number[]) => indexes.map(i => options[i].value);

  const _onChange = (indexes: number[]) => {
    onChange(toValue(indexes));
    setFilterValue(indexes as any);
  };

  return (
    <div className="h-full flex justify-center items-center">
      <Select.Searchable
        multiple={multiple}
        value={filterValue}
        onChange={_onChange}
        placeholder={placeholder}
        showOptional={false}
        label={title}
      >
        {Array.isArray(options) &&
          options.map(option => <Select.Option key={option.value}>{option.label}</Select.Option>)}
      </Select.Searchable>
    </div>
  );
};
